module.exports = __webpack_public_path__ + "img/500.395a93cd.png";